import { FeatureCatalog } from "../api/types"

export function isVersionLowerOrEqual(ver1: string, ver2: string) {
  if (ver1 === null || ver2 === null) {
    return false
  }
  const v1 = ver1.split(".")
  const v2 = ver2.split(".")
  if (v1.length < 2 || v2.length < 2) {
    return false
  }

  const v1Major = parseInt(v1[0], 10)
  const v1Minor = parseInt(v1[1], 10)

  const v2Major = parseInt(v1[0], 10)
  const v2Minor = parseInt(v2[1], 10)

  return v1Major < v2Major || (v1Major === v2Major && v1Minor <= v2Minor)
}

export function sortFcsByDate(a: FeatureCatalog, b: FeatureCatalog) {
  return new Date(a.date) < new Date(b.date) ? 1 : -1
}

export function getFcDisplayName(fc: FeatureCatalog) {
  return `${fc.name} ${fc.version} - ${fc.date}`
}